module.exports = __webpack_public_path__ + "img/grey_009.3d45b7f2.png";